function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "#656565"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M59.23 36.786c.503-2.18.77-4.452.77-6.786C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30 1.253 0 2.488-.077 3.7-.226",
  transform: "translate(1 1)"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.415 0c.674 2.171.281 3.723-1.177 4.654-1.46.93-4.386 1.657-8.78 2.179",
  transform: "translate(1 1) translate(8.057 1.657)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.38 3.416c-.254 2.1.038 3.993.876 5.682 2.128 4.29 6.94 10.546 6.518 12.716-.27 1.381-2.311.542-4.965 3.157-1.553 1.53 1.152 4.568-.829 6.121-.578.454-1.945.236-4.07 0-.668-.073-1.76.065-3.277.414M14.126 33.839c2.221-.273 3.718-.353 4.49-.24.998.147 1.952.216 2.189.853.48 1.29-.605 3.649-.588 4.885.015 1.148.671 2.412 0 3.325-.594.808-2.572 1.314-3.87 1.467-1.145.136-4.652.184-7.81-.976-1.74-.64-4.586-2.227-8.537-4.765M8.443 14.253c1.09.899 2.34 1.348 3.747 1.348s2.656-.45 3.746-1.348M8.265 43.226c-.61 2.228-.914 3.904-.914 5.028 0 1.125.305 2.801.914 5.029",
  transform: "translate(1 1) translate(8.057 1.657)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1) translate(30.914 30.914)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 4.486,
  height: 1,
  x: 0.5,
  y: 1.871,
  rx: 0.5,
  transform: "rotate(-25 2.743 1.871)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 4.486,
  height: 1,
  x: 0.5,
  y: 5.954,
  rx: 0.5,
  transform: "scale(1 -1) rotate(-25 -24.114 0)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 3.114,
  height: 1,
  x: 1.186,
  y: 3.913,
  rx: 0.5,
  transform: "matrix(1 0 0 -1 0 7.826)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M20.629 11.568c1.302 1.05 1.904 2.33 1.804 3.84 1.866.22 2.798 1.51 2.798 3.87 0 2.36-1.454 3.49-4.361 3.386.184 2.34-.45 3.912-1.902 4.717-1.453.806-3.286.41-5.499-1.187-1.553 2.03-3.501 2.686-5.846 1.966s-3.345-2.255-3-4.605c-2.373.228-3.853-.573-4.44-2.403-.587-1.83.238-3.21 2.476-4.136-.841-1.42-.68-2.841.484-4.264.22-.27.937-1.007 2.381-1.184.378-.047 1.077.062 2.099.326.594-1.736 1.788-2.604 3.582-2.604 1.12 0 2.357.76 3.713 2.278 2.504-1.05 4.408-1.05 5.71 0z",
  transform: "translate(1 1) translate(33 30.834)"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "round",
  d: "M26.653 18.514c.592-.97 1.219-2.514.347-4.404-.872-1.891-1.62-2.108-3.466-2.518.338-2.534-1.235-4.804-3.118-5.79-1.884-.988-4.39-.466-5.808 1.44-1.517-1.84-3.13-2.32-4.84-1.44-1.273.655-1.815 1.687-1.625 3.097M7.1 21.923c.59.997.686 1.715 2.309 2.172 1.085.306 2.153.18 3.202-.378M14.962 14.273c1.053-.18 1.726-.56 2.985.078.843.426 1.395 1.139 1.655 2.137",
  transform: "translate(1 1) translate(33 30.834)"
}))));

var SvgIconAllergyDust = function SvgIconAllergyDust(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAllergyDust, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-allergy_dust.4b03ec15.svg";
export { ForwardRef as ReactComponent };